export default {
    zh: {
        NewSettlementUnitManagement: '结算单位管理',
        NewSettlementUnitApply: '结算单位申请',
        registerDate: '注册日期',
        isStart: '是否启用',
        enabled: '已启用',
        disabled: '已禁用',
        isOverseas: '是否海外',
        MDMAdd: 'MDM新增',
        SupplierDataEdit: '供应商主数据详细编辑',
        SupplierDataMaintenance: '供应商主数据维护',
        SupplierDataInfo: '供应商主数据信息',
        qualificationFile: '资质文件',
        LegalFile: '法务文件',
        ContactEmail: '联系人邮箱',
        SocialUnifiedCreditCode: '社会统一信用代码',
        department: '部门',
        openBank: '开户行',
        openBankAddress: '开户行地址',
        accounts: '帐号',
        ShareholdingRatio: '控股比例',
        isCreditPayment: '是否信用支付',
        LegalFileManage: '法务文件查询',
        supplierName: '供应商名称',
        ApplicationNumber: '申请编号',
        suppliercodeOrInvitationCode: '供应商编码/邀请码',
        applyFileType: '申请文件类型',
        LegalFileDetail: '法务用印文件申请详细',
        ConfidentialityAgreementApply: '保密协议申请',
        baseInfo: '基础信息',
        systemApplyNumber: '系统申请编号',
        title: '标题',
        ContractingParties: '合同签约方',
        applyDate: '申请日期',
        agent: '经办人',
        agentDepartment: '经办人所属部门',
        isApproval: '是否涉及相关人员审批',
        isMCDTemplate: '是否使用麦当劳标准模板',
        ChooseLegal: '选择法务',
        ContractName: '合同名称',
        ContractNo: '合同编号',
        CounterpartSubject: '相对方主体',
        secrecyInfoScene: '保密信息及使用场景',
        ContractVersion: '供应商合同提案',
        SealRelated: '印章相关',
        OurPrincipalName: '我方主体名称',
        NameOpposite: '相对方名称',
        supplierAddress: '供应商地址',
        supplierTel: '供应商联系电话',
        supplierEmail: '供应商邮箱',
        OurSecrecyInfo: '我方保密信息',
        OppositeSecrecyInfo: '相对方保密信息',
        PurposeAndScope: '使用目的和范围',
        contractSignDate: '合同拟签署日期',
        DraftContract: '合同初稿（供应商签字盖章）',
        ApprovalStatus: '审批状态',
        isSeal: '是否涉及用印',
        SealName: '印章名称',
        SealKeeper: '印章保管员',
        SystemApplyNo: '系统申请编号',
        EngagementManage: 'Engagement 管理',
        EngagementDetail: 'Engagement 详情',
        DownloadPDF: '下载PDF',
        formType: '表单类型',
        Protocoltype: '协议类型',
        supplierMainName: '供应商主体名称',
        ContractOverview: '合同概述',
        contractValidity: '合同有效期',
        isAutoRenewal: '是否包含自动续期条款',
        AutoRenewalCondition: '简述自动续期条件',
        amountAndType: '合同涉及金额类型',
        addressType: '地址类型',
        detailAddress: '详细地址',
        contacts: '联系人',
        Postcode: '邮编',
        supplierCategory: '供应品类',
        leastContact: '至少添加一个联系人',
        leastAddress: '至少添加一个地址',
        EngagementForm: 'Engagement Form',
        sendToMDM: '下发MDM',
        placeFile: '归档',
        code: '编码',
        queryHistory: '历史审批通过版本',
        creator: '创建人',
        supplierCode: '供应商编号',
        beginDate: '创建日期',
        to: '至',
        riqi: '日期',
        status: '状态',
        appr_pass: '供应商签署合同上传',
        downloadTemplate: '范本',
        fileListWater: '已批准合同',
        fileType: '申请文件类型',
        supplierNameCn: '结算单位中文名称',
        suppliernameEn: '结算单位英文名称',
        queryConditionSupplierCode: '结算单位编码',
        groupCode: '供应商编码',
        groupShortName: '供应商简称',
        SubmitBy: '选择审批人',
        address: '结算单位地址',
        dataInfo: '主数据信息',
        tel: '联系电话',
        addressInformation: '选择相关结算工厂',
        addressInformationTip: '（需要将工厂关联至结算单位，才可对该工厂下的物料进行创建与结算。）',
        cra: '注册地址',
        factoryAddress: '工厂地址',
        telephone: '电话',
        email: '邮箱',
        addTo: '添加',
        qualificationDocuments: '资质文档',
        template: '范本',
        historicalFileVersion: '历史文件版本',
        currentVersionFile: '当前版本文件',
        operation: '操作',
        country: '国家',
        province: '省份',
        city: '市/县',
        tmAreaId: '市/区',
        createApplication: '创建申请',
        nameCn: '中文名称',
        nameEn: '英文名称',
        enclosure: '附件',
        settlementUnitDetail: '新结算单位详情编辑',
        nodeName: '审批人',
        approvalRemarks: '审批意见',
    },
    en: {
        NewSettlementUnitManagement: 'NewSettleUnitManage',
        NewSettlementUnitApply: 'NewSettleUnitApply',
        registerDate: 'Date of registration',
        isStart: 'Enable',
        enabled: 'enabled',
        disabled: 'disabled',
        isOverseas: 'Overseas',
        MDMAdd: 'MDM Add',
        SupplierDataEdit: 'Detailed editing of supplier master data',
        SupplierDataMaintenance: 'Supplier master data maintenance',
        SupplierDataInfo: 'Supplier master data information',
        qualificationFile: 'qualification documents',
        LegalFile: 'Legal documents',
        ContactEmail: 'Contact Email',
        SocialUnifiedCreditCode: 'Social unified credit code',
        department: 'department',
        openBank: 'Bank of deposit',
        openBankAddress: 'Bank Address',
        accounts: 'accounts',
        ShareholdingRatio: 'Shareholding Ratio',
        isCreditPayment: 'Credit Payment',
        supplierName: 'Supplier Name',
        ApplicationNumber: 'Application number',
        suppliercodeOrInvitationCode: 'Supplier code / invitation code',
        applyFileType: 'Types of application documents',
        LegalFileDetail: 'LegalFileDetail',
        ConfidentialityAgreementApply: 'Confidentiality agreement application',
        baseInfo: 'Basic information',
        systemApplyNumber: 'System application number',
        title: 'title',
        ContractingParties: 'Contracting parties',
        applyDate: 'apply date',
        agent: 'Agent',
        agentDepartment: 'Department of operator',
        isApproval: 'Whether relevant personnel approval is involved',
        isMCDTemplate: "Is McDonald's standard template used",
        ChooseLegal: 'Choose legal',
        ContractName: 'Contract Name',
        ContractNo: 'Contract No',
        CounterpartSubject: 'Counterpart Subject',
        secrecyInfoScene: 'Confidential information and usage scenarios',
        ContractVersion: 'Contract Version',
        SealRelated: 'Seal Related',
        OurPrincipalName: 'Our Principal Name',
        NameOpposite: 'Name of opposite party',
        supplierAddress: 'Supplier Address',
        supplierTel: 'supplier Tel',
        supplierEmail: 'supplier Email',
        OurSecrecyInfo: 'Our confidential information',
        OppositeSecrecyInfo: 'Confidential information of the opposite party',
        PurposeAndScope: 'Purpose and scope of use',
        contractSignDate: 'Proposed signing date of the contract',
        DraftContract: 'DraftContract',
        ApprovalStatus: 'Approval Status',
        isSeal: 'Is our seal involved',
        SealName: 'Seal Name',
        SealKeeper: 'Seal Keeper',
        SystemApplyNo: 'System application number',
        EngagementManage: 'Engagement Manage',
        EngagementDetail: 'Engagement Detail',
        DownloadPDF: 'Download PDF',
        formType: 'formType',
        Protocoltype: 'Protocol type',
        supplierMainName: 'Supplier principal name',
        ContractOverview: 'ContractOverview',
        contractValidity: 'Validity of contract',
        isAutoRenewal: 'Include automatic renewal clause',
        AutoRenewalCondition: 'Brief introduction of automatic renewal conditions',
        amountAndType: 'Types of amount involved in the contract',
        addressType: 'addressType',
        detailAddress: 'detailAddress',
        contacts: 'contacts',
        Postcode: 'Postcode',
        leastContact: 'Add at least one contact',
        sendToMDM: 'send To MDM',
        placeFile: 'place on file',
    }
}